const scrollToTarget = (e) => {
    e.preventDefault();
    const clickedElement = e.currentTarget;
    const id = clickedElement.getAttribute('href').slice(1);

    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const target = document.getElementById(id);
    if(target) {
        const scrollOptions = {
            top: target.offsetTop - headerHeight * 2,
            behavior: 'smooth'
        };
        window.scrollTo(scrollOptions);
    }
};

let isFooterHidden = false;

const checkScroll = () => {
    const quoteSection = document.getElementById('quote');

    if(!quoteSection) return;

    const footer = document.getElementById('cta-banner');
    const rect = quoteSection.getBoundingClientRect();
    if(rect.top < window.innerHeight && !isFooterHidden) {
        footer.classList.add('hide');
        isFooterHidden = true;
    } else if(rect.top >= window.innerHeight && isFooterHidden) {
        footer.classList.remove('hide');
        isFooterHidden = false;
    }
};

const eventHandler = () => {
    const scrollToButtons = document.querySelectorAll('#cta-button');
    if (scrollToButtons) {
        Array.prototype.forEach.call(scrollToButtons, el => {
            el.addEventListener('click', scrollToTarget, false);
        });
    }
};

const ctaCard = () => {
    checkScroll();
    eventHandler();
    window.addEventListener('scroll', checkScroll);
};

export default ctaCard;
